import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IdAndAlias, LocalUser, UserService as US, UserWithEmplId } from '../domain';
import { AppSettings } from '../app-settings';
import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService implements US {
	
	constructor(private http: HttpClient, private appSettings: AppSettings) { }

	public config(): Promise<null>{
		return Promise.resolve(null);
	}
	
	public getAvatarUrl(userId: number): string {
		return this.appSettings.APIURL + '/user/Avatar/' + userId;		
	}
	
	public getAvatarUrlAsync(userId: number): Observable<string> {		
		return this.http.get(this.getAvatarUrl(userId), { responseType: 'blob' }).pipe(
			map(blob => URL.createObjectURL(blob))
		);
	}

	public getInitialsAvatarUrl(userId: number) : Observable<string> {
		return this.http.get(`${this.appSettings.APIURL}/user/initialsAvatar/${userId}`, { responseType: 'blob' }).pipe(
			map(blob => URL.createObjectURL(blob))
		);
	}

	public search(nameFragment: string, max: number, includeDeleted : boolean = false): Promise<UserWithEmplId[]> {
		let url = this.appSettings.APIURL + '/user/search/?nameFragment=' + (nameFragment || '') + '&max=' + max + '&includeDeleted=' + includeDeleted;
		return firstValueFrom(this.http.get(url))
			.then(json => (<any[]>json['result']).map(UserWithEmplId.fromJson));
	}

	public getAllLocal(): Promise<LocalUser[]> {
		return firstValueFrom(this.http.get(this.appSettings.APIURL + '/user/all-local'))
			.then(json => (<any[]>json).map(LocalUser.fromJson));
	}

	public importFromDirectoryIfNecessary(userId: number): void {
		firstValueFrom(this.http.post(this.appSettings.APIURL + '/user/import_if_necessary/' + userId, null));
	}

	public getUserIdAliasMap(): Promise<IdAndAlias[]> {
		return firstValueFrom(this.http.get(this.appSettings.APIURL + '/user/user-id-aliases'))
			.then(json => (<any[]>json).map(IdAndAlias.fromJson));
	}

	public spoofUser(userId: number): Promise<unknown> {
		return firstValueFrom(this.http.post(this.appSettings.APIURL + '/user/spoof-user/?userId=' + userId, null));
	}

	public unspoofUser(): Promise<unknown> {
		return firstValueFrom(this.http.delete(this.appSettings.APIURL + '/user/spoof-user'));
	}
}

